import { styled, Grid } from '@material-ui/core';
import { brand } from '../../theme';

const OPTIONS = [
    { v: "off",       label: "Off",           sub: "Score only — no reminder field." },
    { v: "secondary", label: "Reminder Beer", sub: "Tasters can pick a backup beer (unscored)." },
    { v: "notes",     label: "Notes",         sub: "Free-text reminder field." },
    { v: "both",      label: "Both",          sub: "Show both — see which tasters use." },
];

export const ReminderModePicker = styled(({ value, onChange, className, ...p }: any) => {
    const current = value || "off";
    return (
        <Grid item className={className} {...p}>
            <div className="card">
                <div className="header">
                    <div className="header-icon" aria-hidden>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M2 3h10M2 7h10M2 11h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                        </svg>
                    </div>
                    <div className="header-copy">
                        <div className="title">Round Reminder</div>
                        <div className="subtitle">
                            Optional second-guess field shown on every round. Per-event so different events can run different modes.
                        </div>
                    </div>
                </div>
                <div className="grid">
                    {OPTIONS.map((opt) => {
                        const active = current === opt.v;
                        return (
                            <button
                                key={opt.v}
                                type="button"
                                onClick={() => onChange && onChange({ reminderMode: opt.v })}
                                className={`opt${active ? " opt--on" : ""}`}
                                data-testid={`reminderMode-${opt.v}`}
                            >
                                <div className="opt-label">{opt.label}</div>
                                <div className="opt-sub">{opt.sub}</div>
                            </button>
                        );
                    })}
                </div>
            </div>
        </Grid>
    );
})(({ theme }) => ({
    marginTop: theme.spacing(2),
    "& .card": {
        background: brand.white,
        border: `1.5px solid #C8BFB0`,
        borderRadius: 8,
        padding: theme.spacing(1.75, 1.75, 1.25),
    },
    "& .header": {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1.25),
        marginBottom: 4,
    },
    "& .header-icon": {
        width: 26,
        height: 26,
        borderRadius: 7,
        flexShrink: 0,
        background: brand.amberLight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: brand.amberDeep,
    },
    "& .header-copy": {
        flex: 1,
        minWidth: 0,
    },
    "& .title": {
        fontSize: 14,
        fontWeight: 700,
        color: brand.text,
    },
    "& .subtitle": {
        fontSize: 11,
        color: brand.textSec,
        marginTop: 1,
        lineHeight: 1.35,
    },
    "& .grid": {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 6,
        marginTop: 10,
    },
    "& .opt": {
        textAlign: "left",
        padding: theme.spacing(1, 1.25),
        borderRadius: 8,
        border: `1.5px solid ${brand.sep}`,
        background: brand.white,
        cursor: "pointer",
        fontFamily: "inherit",
        boxShadow: "none",
        transition: "all .15s",
    },
    "& .opt--on": {
        border: `2px solid ${brand.amber}`,
        background: brand.amberLight,
        boxShadow: `0 2px 10px ${brand.amber}33`,
    },
    "& .opt-label": {
        fontSize: 12,
        fontWeight: 800,
        color: brand.text,
        letterSpacing: 0.2,
    },
    "& .opt--on .opt-label": {
        color: brand.amberDeep,
    },
    "& .opt-sub": {
        fontSize: 10,
        color: brand.textSec,
        marginTop: 2,
        lineHeight: 1.3,
    },
}));
